import { extend, setInteractionMode } from 'vee-validate';
import {
 required, email, min, max, min_value, max_value, image, regex, numeric,
} from 'vee-validate/dist/rules';
import locale from 'vee-validate/dist/locale/en.json';

// only validate when dirty
const eagerDirtyValidation = (args) => {
  const { errors, flags } = args;
  if (errors.length) {
    return {
      on: ['input', 'change'],
    };
  }
  if (flags.dirty) {
    return {
      on: ['change', 'blur'],
    };
  }
  return {
    on: [],
  };
};

setInteractionMode('eagerDirty', eagerDirtyValidation);

// the validations we are using
extend('email', {
  ...email,
  message: locale.messages.email,
});

extend('min', {
  ...min,
  message: locale.messages.min,
});

extend('max', {
    ...max,
    message: locale.messages.max,
});

extend('min_value', {
    ...min_value,
    message: locale.messages.min_value,
});

extend('max_value', {
    ...max_value,
    message: locale.messages.max_value,
});

extend('required', {
  ...required,
  message: locale.messages.required,
});

extend('image', {
    ...image,
    message: locale.messages.image,
});

extend('regex', {
    ...regex,
    message: locale.messages.regex,
});

extend('passwordMatch', {
  params: ['target'],
  validate(value, { target }) {
    return value === target;
  },
  message: 'Password confirmation does not match',
});

extend('slug_free', {
    validate: (val, bool) => bool[0] === 'true',
    message: ' ', // message must have an empty space so nothing shows up
});

extend('url', {
  validate(value) { 
    const pattern = new RegExp('((http|https)://)(www.)?' 
    + '[a-zA-Z0-9@:%\-._\\+~#?&\/\/=]{2,256}\\.[a-z]'
    + '{2,6}\\b([-a-zA-Z0-9@:%._\\+~#?&//=]*)')
    return pattern.test(value);
  },
  message: 'Please enter a valid link',
});

extend('numeric', {
  ...numeric,
  message: locale.messages.numeric,
});

export default {
  name: 'Validation',
};
